import type { TSerializedWidget } from 'src/entities/workspace/types';
import type {
  TAlertsManagerSerializedInternalState,
  AlertsManagerWidgetEntity,
} from 'src/pages/dashboard/features/alerts-manager-widget/AlertsManagerWidget.entity';

export function serializeAlertsManagerWidget(widget: AlertsManagerWidgetEntity): TSerializedWidget {
  const internalState: TAlertsManagerSerializedInternalState = {
    wellId: widget.wellId,
    stateParams: { ...widget.stateParams },
    isEditMode: widget.isEditMode,
  };

  return {
    wellId: widget.wellId,
    uuid: widget.uuid,
    type: widget.type,
    groupId: widget.groupId,
    size: {
      w: widget.size.w,
      h: widget.size.h,
    },
    position: {
      x: widget.position.x,
      y: widget.position.y,
    },
    isFullscreen: widget.isFullscreen,
    internalState,
  };
}
